import { Context, Effect, Layer } from "effect";
import { immutableModelDependencyFailure, type ImmutableModelDependencyFailure } from "./model.ts";

export class ImmutableModelIdentityIo extends Context.Service<ImmutableModelIdentityIo, {
  readonly allocate: Effect.Effect<string, ImmutableModelDependencyFailure>;
}>()("workerstation/frontend/ImmutableModelIdentityIo") {}

export const ImmutableModelIdentityIoLive = Layer.succeed(ImmutableModelIdentityIo, {
  allocate: Effect.try({ try: () => globalThis.crypto.randomUUID(), catch: immutableModelDependencyFailure })
});

export const ImmutableModelIdentityIoTest = (identity: string) => Layer.succeed(ImmutableModelIdentityIo, {
  allocate: Effect.succeed(identity)
});
